export const FETCH_BACKEND_META = 'FETCH_BACKEND_META'
export const fetchBackendMeta = (data) => ({
  type: FETCH_BACKEND_META,
  payload: data,
})
